"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowButton = void 0;
var theme_ui_1 = require("theme-ui");
var theme_1 = require("../../../theme");
var ArrowButton = function (_a) {
    var direction = _a.direction, onClick = _a.onClick;
    var clipPath = direction === "left"
        ? "polygon(0px 11px, 13px 0px, 15px 2.2px, 4.2px 11px, 15px 19.8px, 13px 22px)"
        : "polygon(2px 0px, 15px 11px, 2px 22px, 0px 19.8px, 10.8px 11px, 0px 2.2px)";
    return (theme_ui_1.jsx(theme_ui_1.Box, { "data-testid": "carousel-arrow-" + direction, sx: {
            background: "none",
            border: "0",
            padding: "0",
            outline: "none",
            cursor: "pointer",
            variant: "tertiary",
        }, as: "button", onClick: onClick },
        theme_ui_1.jsx(theme_ui_1.Box, { sx: {
                background: theme_1.theme.colors.primary,
                clipPath: clipPath,
                width: "15px",
                height: "22px",
            } })));
};
exports.ArrowButton = ArrowButton;
